module.exports = __webpack_public_path__ + "static/media/devrim-yasar.d215be54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/devrim-yasar.jpg
// module id = 210
// module chunks = 0